// import axios from "axios";
// import { toast } from "react-toastify";
// import { createBrowserHistory } from "history";

// // Create history instance
// const history = createBrowserHistory();

// // Create Axios instance without baseURL
// const api = axios.create({});

// // Request Interceptor — inject token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token"); // Get token directly
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 / 403 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const status = error?.response?.status;
//     if (status === 401) {
//       history.push("/session-expired");
//     } else if (status === 403) {
//       history.push("/un-authorized");
//     } else {
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;


// import axios from "axios";
// import { toast } from "react-toastify";
// // import { createBrowserHistory } from "history";

// // Create history instance
// // const history = createBrowserHistory();

// // Create Axios instance without baseURL
// const api = axios.create({});

// // Request Interceptor — inject token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token"); // Get token directly
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 / 403 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const status = error?.response?.status;
//     if (status === 401) {
//       // history.push("/session-expired");
//       console.error(error);
//     } else if (status === 403) {
//       // history.push("/un-authorized");
//       console.error(error);
//     } else {
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;


// // common/apiClient.js
// import axios from "axios";
// import { toast } from "react-toastify";

// // Create a navigation handler that will be set by your App component
// let navigationHandler = null;

// export const setNavigationHandler = (handler) => {
//   navigationHandler = handler;
// };

// // Create Axios instance without baseURL
// const api = axios.create({});

// // Request Interceptor — inject token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
    
//     // Check if token exists for protected routes
//     const publicPaths = ["/", "/login", "/un-authorized", "/register", "/forgot-password", "/reset-password", "/not-found"];
//     const currentPath = window.location.pathname;

//     // Check if current path starts with any public path
//     const isPublic = publicPaths.some(
//       (path) =>
//         currentPath === path ||
//         (path === "/reset-password" && currentPath.startsWith("/reset-password"))
//     );
    
//     // If no token and trying to access protected route
//     if (!token && !isPublic) {
//       // Navigate to un-authorized
//       if (navigationHandler) {
//         navigationHandler("/un-authorized");
//       } else {
//         window.location.href = "/un-authorized";
//       }
//       return Promise.reject(new axios.Cancel("No authentication token found"));
//     }
    
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 / 403 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Don't process cancelled requests
//     if (axios.isCancel(error)) {
//       return Promise.reject(error);
//     }

//     const status = error?.response?.status;
//     const currentPath = window.location.pathname;
    
//     if (status === 401 || status === 403) {
//       // Clear token for 401
//       if (status === 401) {
//         localStorage.removeItem("token");
//       }
      
//       // Navigate to un-authorized page
//       if (currentPath !== "/un-authorized") {
//         if (navigationHandler) {
//           navigationHandler("/un-authorized");
//         } else {
//           window.location.href = "/un-authorized";
//         }
//       }
//     } else {
//       // Show error toast for other errors
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     }
    
//     return Promise.reject(error);
//   }
// );

// export default api;


//////////////

// // common/apiClient.js
// import axios from "axios";
// import { toast } from "react-toastify";

// // Create a navigation handler that will be set by your App component
// let navigationHandler = null;

// export const setNavigationHandler = (handler) => {
//   navigationHandler = handler;
// };

// // Create Axios instance without baseURL
// const api = axios.create({});

// // Flag to prevent multiple redirects
// let isRedirecting = false;

// // Request Interceptor — inject token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
    
//     // Check if token exists for protected routes
//     const publicPaths = ["/", "/login", "/un-authorized", "/register", "/forgot-password", "/reset-password", "/not-found"];
//     const currentPath = window.location.pathname;

//     // Check if current path starts with any public path
//     const isPublic = publicPaths.some(
//       (path) =>
//         currentPath === path ||
//         (path === "/reset-password" && currentPath.startsWith("/reset-password"))
//     );
    
//     // If no token and trying to access protected route
//     if (!token && !isPublic) {
//       // Prevent multiple redirects
//       if (!isRedirecting) {
//         isRedirecting = true;
        
//         // Navigate to un-authorized immediately
//         if (navigationHandler) {
//           navigationHandler("/un-authorized");
//         } else {
//           window.location.href = "/un-authorized";
//         }
        
//         // Reset flag after a short delay
//         setTimeout(() => {
//           isRedirecting = false;
//         }, 100);
//       }
      
//       // Create a proper error to reject the request
//       const cancelError = new Error("No authentication token found");
//       cancelError.isAuthError = true;
      
//       // Return a rejected promise to prevent the request
//       return Promise.reject(cancelError);
//     }
    
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 / 403 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Don't process auth errors from request interceptor
//     if (error?.isAuthError) {
//       return Promise.reject(error);
//     }
    
//     // Don't process cancelled requests
//     if (axios.isCancel(error)) {
//       return Promise.reject(error);
//     }

//     const status = error?.response?.status;
//     const currentPath = window.location.pathname;
    
//     if (status === 401 || status === 403) {
//       // Clear token for 401
//       if (status === 401) {
//         localStorage.removeItem("token");
//       }
      
//       // Navigate to un-authorized page
//       if (currentPath !== "/un-authorized" && !isRedirecting) {
//         isRedirecting = true;
        
//         if (navigationHandler) {
//           navigationHandler("/un-authorized");
//         } else {
//           window.location.href = "/un-authorized";
//         }
        
//         // Reset flag after a short delay
//         setTimeout(() => {
//           isRedirecting = false;
//         }, 100);
//       }
//     } else {
//       // Show error toast for other errors
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     }
    
//     return Promise.reject(error);
//   }
// );

// export default api;


//////////////////////


// common/apiClient.js
// import axios from "axios";
// import { toast } from "react-hot-toast";

// // Create a navigation handler that will be set by your App component
// let navigationHandler = null;

// export const setNavigationHandler = (handler) => {
//   navigationHandler = handler;
// };

// // Custom error class for auth failures
// class AuthError extends Error {
//   constructor(message) {
//     super(message);
//     this.name = 'AuthError';
//   }
// }

// // Create Axios instance without baseURL
// const api = axios.create({});

// // Request Interceptor — inject token
// api.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
    
//     // Check if token exists for protected routes
//     const publicPaths = ["/", "/login", "/un-authorized", "/register", "/forgot-password", "/reset-password", "/not-found"];
//     const currentPath = window.location.pathname;

//     // Check if current path starts with any public path
//     const isPublic = publicPaths.some(
//       (path) =>
//         currentPath === path ||
//         (path === "/reset-password" && currentPath.startsWith("/reset-password"))
//     );
    
//     // If no token and trying to access protected route
//     if (!token && !isPublic) {
//       // Navigate immediately
//       const navigate = () => {
//         if (navigationHandler) {
//           navigationHandler("/un-authorized");
//         } else {
//           window.location.href = "/un-authorized";
//         }
//       };
      
//       // Execute navigation asynchronously to avoid blocking
//       Promise.resolve().then(navigate);
      
//       // Reject the request immediately
//       return Promise.reject(new AuthError("No authentication token found"));
//     }
    
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor — handle 401 / 403 globally
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Skip processing for auth errors from request interceptor
//     if (error instanceof AuthError) {
//       return Promise.reject(error);
//     }
    
//     // Don't process cancelled requests
//     if (axios.isCancel(error)) {
//       return Promise.reject(error);
//     }

//     const status = error?.response?.status;
//     const currentPath = window.location.pathname;
    
//     if (status === 401) {
//       // Clear token for 401
//       if (status === 401) {
//         localStorage.removeItem("token");
//       }
      
//       // Navigate to un-authorized page
//       if (currentPath !== "/un-authorized") {
//         const navigate = () => {
//           if (navigationHandler) {
//             navigationHandler("/un-authorized");
//           } else {
//             window.location.href = "/un-authorized";
//           }
//         };
        
//         Promise.resolve().then(navigate);
//       }
//     } else {
//       // Show error toast for other errors
//       toast.error(error?.response?.data?.message || "Something went wrong");
//     }
    
//     return Promise.reject(error);
//   }
// );

// export default api;


// apiClient.js
import axios from "axios";

/**
 * Navigation handler reference
 * Used to perform redirects from Axios interceptors
 * (because hooks like useNavigate cannot be used here)
 */
let navigationHandler = null;

/**
 * Setter to inject navigation function (useNavigate)
 * from React components during app initialization
 */
export const setNavigationHandler = (handler) => {
  navigationHandler = handler;
};

/**
 * Create Axios instance
 */
const api = axios.create({});

/* ----------------------------------------
   REQUEST INTERCEPTOR
---------------------------------------- */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // If token exists, attach it to Authorization header
    // Otherwise, allow the request to proceed as Guest access
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ----------------------------------------
   RESPONSE INTERCEPTOR
---------------------------------------- */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const currentPath = window.location.pathname;

    // If backend returns 401 (Unauthorized)
    if (status === 401) {
      // Clear invalid or expired token
      localStorage.removeItem("token");
      
      // If user is currently inside admin routes, redirect to Unauthorized page
      if (currentPath.startsWith("/admin-panel")) {
        if (navigationHandler) {
          navigationHandler("/un-authorized");
        } else {
          // Fallback navigation if handler is not set
          window.location.href = "/un-authorized";
        }
      } else {
        // For non-admin routes, redirect to login page
        if (navigationHandler) {
          navigationHandler("/login");
        } else {
          // Fallback navigation if handler is not set
          window.location.href = "/login";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
